import { isEmptyObject } from '../../tools/utils/objectUtils';
import { objectEntries } from '../../tools/utils/polyfills';
import { dateNow } from '../../tools/utils/timeUtils';
import { generateUUID } from '../../tools/utils/stringUtils';
import { SESSION_EXPIRATION_DELAY, SESSION_TIME_OUT_DELAY } from './sessionConstants';
import { isValidSessionString, SESSION_ENTRY_REGEXP, SESSION_ENTRY_SEPARATOR } from './sessionStateValidation';
export const EXPIRED = '1';
export function getCreatedDate(state) {
    return state.created ? Number(state.created) : undefined;
}
export function getExpireDate(state) {
    const expireDate = state.expire && Number(state.expire);
    const createdDate = getCreatedDate(state);
    if (expireDate && createdDate) {
        return Math.min(expireDate, createdDate + SESSION_TIME_OUT_DELAY);
    }
}
export function getExpiredSessionState(previousSessionState, configuration) {
    const expiredSessionState = {
        isExpired: EXPIRED,
    };
    if (configuration.trackAnonymousUser && previousSessionState?.anonymousId) {
        expiredSessionState.anonymousId = previousSessionState?.anonymousId;
    }
    return expiredSessionState;
}
export function isSessionInNotStartedState(session) {
    return isEmptyObject(session);
}
export function isSessionStarted(session) {
    return !isSessionInNotStartedState(session);
}
export function isSessionInExpiredState(session) {
    return session.isExpired !== undefined || !isActiveSession(session);
}
// An active session is a session in either `Tracked` or `NotTracked` state
function isActiveSession(sessionState) {
    const expireDate = getExpireDate(sessionState);
    return expireDate ? dateNow() < expireDate : false;
}
export function expandSessionState(session) {
    session.expire = String(dateNow() + SESSION_EXPIRATION_DELAY);
}
export function toSessionString(session) {
    return (objectEntries(session)
        // we use `aid` as a key for anonymousId
        .map(([key, value]) => (key === 'anonymousId' ? `aid=${value}` : `${key}=${value}`))
        .join(SESSION_ENTRY_SEPARATOR));
}
export function toSessionState(sessionString) {
    const session = {};
    if (isValidSessionString(sessionString)) {
        sessionString.split(SESSION_ENTRY_SEPARATOR).forEach((entry) => {
            const matches = SESSION_ENTRY_REGEXP.exec(entry);
            if (matches !== null) {
                const [, key, value] = matches;
                if (key === 'aid') {
                    // we use `aid` as a key for anonymousId
                    session.anonymousId = value;
                }
                else {
                    session[key] = value;
                }
            }
        });
    }
    return session;
}
export function initializeSession(state, configuration) {
    if (isSessionInNotStartedState(state)) {
        if (configuration.trackAnonymousUser) {
            state.anonymousId = generateUUID();
        }
        return getExpiredSessionState(state, configuration);
    }
    return state;
}
export function expandOrRenew(state, configuration) {
    // prevent renewing if state is altered by a 3rd party (e.g. adblocker deleting the cookie)
    if (isSessionInNotStartedState(state)) {
        return state;
    }
    let newState = state;
    if (isSessionInExpiredState(state)) {
        newState = getExpiredSessionState(state, configuration);
    }
    if (!newState.id) {
        newState.id = generateUUID();
        newState.created = String(dateNow());
    }
    if (configuration.trackAnonymousUser && !newState.anonymousId) {
        newState.anonymousId = generateUUID();
    }
    delete newState.isExpired;
    expandSessionState(newState);
    return newState;
}
export function expandOnly(state) {
    if (isSessionInExpiredState(state) || isSessionInNotStartedState(state) || !state.id) {
        return state;
    }
    expandSessionState(state);
    return state;
}
//# sourceMappingURL=sessionState.js.map